// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm icons:create to update
// Do not edit
import type { SVGProps } from 'react';

export const IconImageSvg = (props: SVGProps<SVGSVGElement>): JSX.Element => (
  <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M2 5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5Zm18 0H4v14h16V5Z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7.47 10.248a2 2 0 0 1 3.056.02l3.541 4.25 1.436-1.435a2 2 0 0 1 2.976.165l3.302 4.127a1 1 0 1 1-1.562 1.25l-3.302-4.128-1.436 1.436a2 2 0 0 1-2.95-.134l-3.542-4.25-5.23 6.102a1 1 0 1 1-1.518-1.302l5.23-6.101ZM13 9a2 2 0 1 1 4 0 2 2 0 0 1-4 0Z"
      clipRule="evenodd"
    />
  </svg>
);
